import { memo, useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import CustomButton from "../component/button";
import { json, useNavigate } from "react-router-dom";
import { toastMsg } from "../component/toast";
import { AppContext } from "../context/AppContext";
import { ApiConfig } from "../Api/ApiConfig";
import { PostCallWithErrorResponse } from "../Api/ApiServices";

const PersonalityReoprtALert = memo((props) => {

    const { adminData } = useContext(AppContext)

    const { isShowCandidateReport, setIsShowCandidateReport, userId, code, credits, userName, getList, candidateName } = props

    const [isGenerating, setIsGenarating] = useState(false)

    const savePersonalityReport = (report) => {

        setIsGenarating(true)



        const payload = {
            "userId": userId,
            "code": code,
            "personalityReport": "",
            Admin: adminData?.email
        }
        toastMsg('success', `Detailed Personality report for ${userName} is getting processed , once ready it will be emailed to you`)
        setIsShowCandidateReport(false)
        setIsGenarating(false)
        getList(code)

        PostCallWithErrorResponse(ApiConfig.SAVE_PERSONALITY_REPORT, payload).then((res) => {

            if (res?.json?.response?.status) {
                // toastMsg('success', res?.json?.response?.statusMessage)


            } else {
                // toastMsg('error', res?.json?.response?.statusMessage)
            }


        })

    }


    const navigate = useNavigate()

    return (
        <>
            <Modal show={isShowCandidateReport}
                onHide={() => setIsShowCandidateReport(false)}
                centered
                size="md">
                <Modal.Body>
                    <div className="mt-2">
                        <div >
                            <h6 className="text-center interRegular">Are you sure you want to generate a detailed personality report for {userName}</h6>
                        </div>
                        <div className="d-flex justify-content-center gap-1">
                            <CustomButton
                                title="Yes"
                                isLoading={isGenerating}
                                handleClick={() => {

                                    if (credits[0]?.available == 0) {

                                        toastMsg('error', 'You can generate up to 10 detailed personality reports for each job. The limit for this job has already been reached. If you need to generate additional reports, please contact your LYWO representative.')
                                        return
                                    }
                                    savePersonalityReport()
                                    // navigate(`/DetailedPersonalityReport/${code}/${userId}`)
                                }}
                            />
                            <CustomButton
                                title="No"
                                buttonType='secondary'
                                handleClick={() => setIsShowCandidateReport(false)}
                            />

                        </div>
                        <div className="mt-2">
                            <h6 className="text-center interRegular">You can download a total of 10 reports per job.<br /> ({credits[0]?.available}/10 left)</h6>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )

})

export default PersonalityReoprtALert